import { ITrazabilidad } from "../global";
import { ISolicitudCanje, ISolicitudEvento } from "../marketing";
import { Pais } from "../system-settings";
import { ObservacionesCCorporativos } from "./prospecto.interface";

export interface IProspectoCorporativoResp {
  count: number;
  numero_paginas: number | undefined;
  next: string | undefined;
  num_pages: string | undefined;
  previous: string | undefined;
  data: IProspectoCorporativo[];
  tiene_prospecto?:boolean;
}

export interface IDataProspectoCorporativoParams extends Partial<IProspectoCorporativo> {
  page?: number;
  page_size?: number;
  user_create?: string;
  filterByState?: boolean;
  fecha_solicitud_after?: string;
  fecha_solicitud_before?: string;
}


export interface IProspectoCorporativo {
  tipo_identificacion: string;
  identificacion: string;
  razon_social?: string;
  fecha_nacimiento?: string;
  edad?: number;
  celular: string;
  telefono?: string;
  es_discapacitado?: boolean;
  es_tercera_edad?: boolean;
  pais?: string;
  nacionalidad?: string;
  residencia_permanente?: boolean;
  es_coorporativo?: boolean;
  linea?: number | null;

  tipo_contribuyente?: string;
  estado_contribuyente_ruc?: string;
  regimen?: string;
  actividad_economica_principal?: string;

  puntaje_score?: number;
  puntaje_score_sobreendeudamiento?: number;
  puntaje_score_empresa?: number;
  segmentacion?: string;

  es_curador_tutor?: boolean;
  es_bono_humano?: boolean;
  es_ayuda_social?: boolean;

  url_foto_tutor_discapacidad?: string;
  url_foto_documento_legal_representante?: string;
  url_foto_bono_desarrollo_humano?: string;

  // observaciones?: ObservacionesCCorporativos;
  identificacion_carga_personal?: string;
  razon_social_carga_personal?: string;

  tipo_identificacion_beneficio?: string;
  ced_beneficio_tutordiscapacidad?: string;
  nombre_beneficio_tutordiscapacidad?: string;
  bool_ced_beneficio_tutordiscapacidad?: boolean;

  observacion_vendedor?: string;

  // Propiedades opcionales del segundo conjunto (sin repeticiones)
  id_prospecto_corporativo?: string;
  estado?: boolean;
  fecha_creacion?: string;
  fecha_modificacion?: string;
  codigo?: string;
  numero_referencia?: string;
  nombre_comercial?: any;
  estado_prospecto?: string;
  cliente?: any;
  contrato?: any;
  codigo_otp?: any;
  user_create?: string;
  empresa_create?: string;
  area_create?: string;
  departamento_create?: string;
  canal_venta_create?: string;
  motivo_rechazo?: string;
  supervisor?: any;
  observaciones?: ObservacionesCCorporativos & {
    observacion_cancelar?: string;
    observacion_vendedor?: string;
  };
  condicion_venta?: CondicionVentaCorporativa | string | null;
  requiere_inspeccion?: boolean;
  requiere_cotizacion?: boolean;
  pais_data?: Pais;
  trazo_venta_data?: ITrazabilidad[];
  forma_pago?: string;

  email?: string;
  persona_contacto?: string;
  direccion?: string;

  solicitud_canje?: string;
  solicitud_canje_data?: ISolicitudCanje;
  solicitud_evento?: string;
  solicitud_evento_data?: ISolicitudEvento;
  identificacion_canje_evento?: string


  razon_social_option?:string;

  historial_actualizaciones ?: UpdateHistoryProspectoCorporativo[] | null; 

  preventas_corpo_antiguas?: any;
}



export enum CondicionVentaCorporativa {
  CANJE = 'CANJE',
  EVENTO_GRATUITO = 'EVENTO GRATUITO',
  EVENTO_PAGADO = 'EVENTO PAGADO',
}

export const CondicionVentaCorporativaOptions = [
  CondicionVentaCorporativa.CANJE,
  CondicionVentaCorporativa.EVENTO_GRATUITO,
  CondicionVentaCorporativa.EVENTO_PAGADO,
]

export interface IArrCondicionVentaCorporativaOptions {
  id: number;
  nombre: string;
}
export const ArrCondicionVentaCorporativaOptions:IArrCondicionVentaCorporativaOptions[] = [
  {
    id:0,
    nombre:CondicionVentaCorporativa.CANJE,
  },
  {
    id:1,
    nombre:CondicionVentaCorporativa.EVENTO_GRATUITO,
  },
  {
    id:2,
    nombre:CondicionVentaCorporativa.EVENTO_PAGADO,
  },
]



export interface IMotivoRechazoCorporativo {
  id_prospecto_corporativo : string
  motivo_rechazo : string
  razon_social : string
  identificacion : string
  observacion_cancelacion?: string
}

export interface UpdateHistoryProspectoCorporativo {
  uuid:string,
  content:string,
  date:string,
  created_by:string
}